/* sucrase/dist/esm/parser/traverser/index.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    exports.parseFile = parseFile;
    const index_1 = require("bfb18d0576") /* ../tokenizer/index */;
    const charcodes_1 = require("22746c8ce8") /* ../util/charcodes */;
    const base_1 = require("540718e523") /* ./base */;
    const statement_1 = require("e3b9989da1") /* ./statement */;
    function parseFile() {
        // If enabled, skip leading hashbang line.
        if (base_1.state.pos === 0 &&
            base_1.input.charCodeAt(0) === charcodes_1.charCodes.numberSign &&
            base_1.input.charCodeAt(1) === charcodes_1.charCodes.exclamationMark) {
            (0, index_1.skipLineComment)(2);
        }
        (0, index_1.nextToken)();
        return (0, statement_1.parseTopLevel)();
    }
}
